export default [
  'M35 5.83H5C2.7 5.83.83 7.7.83 10v20c0 2.3 1.87 4.17 4.17 4.17h30c2.3 0 4.17-1.87 4.17-4.17V10c0-2.3-1.87-4.17-4.17-4.17zM37.5 30a2.5 2.5 0 01-2.5 2.5H5A2.5 2.5 0 012.5 30V10A2.5 2.5 0 015 7.5h30a2.5 2.5 0 012.5 2.5v20z',
  'M15.46 12.64a.83.83 0 00-.86-.04.83.83 0 00-.44.73v13.33c0 .31.17.59.44.73.12.07.26.1.39.1.16 0 .32-.05.46-.14l10-6.67c.23-.15.37-.42.37-.69s-.14-.54-.37-.69l-9.99-6.66zm.37 12.47V14.89L23.5 20l-7.67 5.11z',
];
